// extracted by mini-css-extract-plugin
export default {"openButton":"MobileFiltersButton_openButton__GCPyT"};